import { jsxs, jsx } from "react/jsx-runtime";
import { useIsCompactVoiceLayout } from "../../hooks/useIsCompactVoiceLayout.js";
const WIDGET_KEYFRAMES = `
@keyframes voice-store-list-fade-in {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}
`;
const ICON_STYLE = { display: "block", flexShrink: 0 };
const DirectionsIcon = () => /* @__PURE__ */ jsx("svg", { width: 16, height: 16, viewBox: "-1.3333 -1.3333 16 16", fill: "none", "aria-hidden": true, focusable: false, style: ICON_STYLE, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60932 1.72375C7.0887 1.20311 6.24478 1.2032 5.7235 1.72399C5.20331 2.24371 5.20308 3.08838 5.72397 3.60982C6.24362 4.13001 7.08816 4.13026 7.60955 3.60935C8.13005 3.08933 8.13038 2.24484 7.60932 1.72375ZM4.78114 0.780731C5.82242 -0.259564 7.51023 -0.261002 8.55215 0.780967C9.59362 1.82249 9.59395 3.51152 8.55192 4.55259C8.20239 4.9018 7.77985 5.13398 7.33333 5.24889V10C7.33333 10.3682 7.03486 10.6667 6.66667 10.6667C6.29848 10.6667 6 10.3682 6 10V5.24932C5.55323 5.13458 5.13042 4.90226 4.78067 4.55213C3.74058 3.51095 3.73883 1.8221 4.78114 0.780731ZM4.65456 8.11604C4.72442 8.47754 4.488 8.82723 4.1265 8.89709C3.18542 9.07896 2.4364 9.35134 1.9416 9.6555C1.41878 9.97688 1.33333 10.2294 1.33333 10.3333C1.33333 10.4059 1.36853 10.5477 1.5894 10.7508C1.81083 10.9544 2.16805 11.1684 2.66566 11.3619C3.65664 11.7473 5.07098 12 6.66667 12C8.26236 12 9.67671 11.7473 10.6677 11.3619C11.1653 11.1684 11.5225 10.9544 11.7439 10.7508C11.9648 10.5477 12 10.4059 12 10.3333C12 10.2294 11.9145 9.97689 11.3917 9.6555C10.8969 9.35134 10.1479 9.07896 9.20683 8.89709C8.84533 8.82723 8.60891 8.47754 8.67878 8.11604C8.74864 7.75453 9.09833 7.51811 9.45983 7.58798C10.4944 7.78791 11.412 8.10286 12.09 8.51962C12.7399 8.91915 13.3333 9.52111 13.3333 10.3333C13.3333 10.9051 13.0327 11.3771 12.6464 11.7323C12.2606 12.087 11.7391 12.3758 11.1509 12.6046C9.97036 13.0637 8.3847 13.3333 6.66667 13.3333C4.94864 13.3333 3.36299 13.0637 2.1824 12.6046C1.59422 12.3759 1.07276 12.0871 0.686955 11.7323C0.300587 11.3771 0 10.9051 0 10.3333C0 9.52111 0.593403 8.91915 1.24335 8.51962C1.92131 8.10286 2.83896 7.78791 3.8735 7.58798C4.235 7.51812 4.58469 7.75454 4.65456 8.11604Z",
    fill: "currentColor"
  }
) });
const CallIcon = () => /* @__PURE__ */ jsx("svg", { width: 16, height: 16, viewBox: "-1.3333 -1.3333 16 16", fill: "none", "aria-hidden": true, focusable: false, style: ICON_STYLE, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M0 2.38095C0 1.06599 1.06599 0 2.38095 0H4.41667C4.6858 0 4.92854 0.161825 5.03205 0.410256L6.28205 3.41026C6.38295 3.65242 6.33245 3.93124 6.15302 4.12263L5.21827 5.11969C5.93624 6.50417 6.84882 7.4698 8.20106 8.18947L9.19526 7.19526C9.38629 7.00424 9.67371 6.94738 9.92308 7.05128L12.9231 8.30128C13.1715 8.40479 13.3333 8.64753 13.3333 8.91667V10.9524C13.3333 12.2673 12.2673 13.3333 10.9524 13.3333C4.90355 13.3333 0 8.42978 0 2.38095ZM2.38095 1.33333C1.80237 1.33333 1.33333 1.80237 1.33333 2.38095C1.33333 7.6934 5.63993 12 10.9524 12C11.531 12 12 11.531 12 10.9524V9.36111L9.82237 8.45377L8.80474 9.4714C8.60651 9.66963 8.30545 9.72267 8.05141 9.60412C6.02098 8.65659 4.74717 7.2847 3.81254 5.28192C3.69732 5.03501 3.74395 4.74282 3.93031 4.54404L4.88549 3.52518L3.97222 1.33333H2.38095Z",
    fill: "currentColor"
  }
) });
const WebsiteIcon = () => /* @__PURE__ */ jsxs("svg", { width: 16, height: 16, viewBox: "-2 -2 16 16", fill: "none", "aria-hidden": true, focusable: false, style: ICON_STYLE, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.60352 6.87891C5.32398 6.0866 6.0866 5.32398 6.87891 5.60352L12.1191 7.45313C12.9635 7.75115 13.021 8.92334 12.2096 9.30208L10.2272 10.2272L9.30208 12.2096C8.92334 13.021 7.75115 12.9635 7.45313 12.1191L5.60352 6.87891ZM8.43815 10.9063L9.07031 9.55339L9.11068 9.47591C9.21287 9.29913 9.36709 9.15727 9.55339 9.07031L10.9063 8.43815L7.09245 7.09245L8.43815 10.9063Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.33333 0C10.8061 0 12 1.19391 12 2.66667V4C12 4.36819 11.7015 4.66667 11.3333 4.66667C10.9651 4.66667 10.6667 4.36819 10.6667 4V2.66667C10.6667 1.93029 10.0697 1.33333 9.33333 1.33333H2.66667C1.93029 1.33333 1.33333 1.93029 1.33333 2.66667V9.33333C1.33333 10.0697 1.93029 10.6667 2.66667 10.6667H4C4.36819 10.6667 4.66667 10.9651 4.66667 11.3333C4.66667 11.7015 4.36819 12 4 12H2.66667C1.19391 12 0 10.8061 0 9.33333V2.66667C0 1.19391 1.19391 0 2.66667 0H9.33333Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.66797 6.13672C4.00429 6.17071 4.26693 6.45484 4.26693 6.80013C4.26684 7.14535 4.00425 7.42956 3.66797 7.46354L3.60026 7.4668H2.80013C2.43199 7.4668 2.13355 7.16825 2.13346 6.80013C2.13346 6.43194 2.43194 6.13346 2.80013 6.13346H3.60026L3.66797 6.13672Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.32878 3.32878C3.58913 3.06843 4.01113 3.06843 4.27148 3.32878L4.87174 3.92904L4.91732 3.97917C5.13089 4.24102 5.11583 4.62766 4.87174 4.87174C4.62765 5.11575 4.24099 5.13088 3.97917 4.91732L3.92904 4.87174L3.32878 4.27148C3.06845 4.01116 3.06851 3.58913 3.32878 3.32878Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.80013 2.13346C7.16832 2.13346 7.4668 2.43194 7.4668 2.80013V3.60026C7.46664 3.96832 7.16822 4.26693 6.80013 4.26693C6.43204 4.26693 6.13362 3.96832 6.13346 3.60026V2.80013C6.13346 2.43194 6.43194 2.13346 6.80013 2.13346Z",
      fill: "currentColor"
    }
  )
] });
const BORDER_COLOR = "#E8E8ED";
const NEUTRAL_SURFACE_BG = "#F6F8FA";
const OPEN_PILL_FG = "#71C184";
const OPEN_PILL_BG = "#F1F9F3";
const CLOSED_PILL_FG = "#9CA3AF";
const CLOSED_PILL_BG = "#F3F4F6";
function buildDirectionsUrl(s) {
  if (s.googleMapsUri) return s.googleMapsUri;
  const dest = encodeURIComponent(`${s.address}, ${s.city}, ${s.state} ${s.zipcode}`);
  return `https://www.google.com/maps/dir/?api=1&destination=${dest}`;
}
function normalizePhoneHref(phone) {
  const digits = phone.replace(/[^\d+]/g, "");
  return `tel:${digits}`;
}
function formatDistance(miles) {
  const v = miles.toFixed(1);
  return `${v} mile${miles === 1 ? "" : "s"} away`;
}
function openPillLabel(store) {
  if (store.openNow) return store.openUntil ? `Open until ${store.openUntil} today` : "Open now";
  return "Closed";
}
const StoreCard = ({ store, isCompact }) => {
  const showOpenPill = typeof store.openNow === "boolean";
  const isOpen = store.openNow === true;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        gap: 16,
        padding: "24px",
        borderBottom: `1px solid ${BORDER_COLOR}`,
        background: "var(--voice-widget-card-bg, #FFFFFF)"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              width: 48,
              height: 48,
              borderRadius: 5.333,
              flexShrink: 0,
              overflow: "hidden",
              background: NEUTRAL_SURFACE_BG,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsx(
              "img",
              {
                src: store.retailerLogoUrl,
                alt: store.retailerName,
                style: { width: 37.333, height: 37.333, objectFit: "contain" },
                onError: (e) => {
                  e.currentTarget.style.display = "none";
                }
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs("div", { style: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }, children: [
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: 8, justifyContent: "space-between" }, children: [
            /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "baseline", gap: 8, minWidth: 0 }, children: [
              /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    fontSize: 16,
                    fontWeight: 600,
                    lineHeight: "24px",
                    color: "var(--voice-widget-fg, #111827)",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: 0
                  },
                  title: store.storeName,
                  children: store.storeName
                }
              ),
              /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    color: "var(--voice-widget-muted, rgba(0,0,0,0.5))",
                    whiteSpace: "nowrap",
                    flexShrink: 0
                  },
                  children: formatDistance(store.distanceMiles)
                }
              )
            ] }),
            showOpenPill && /* @__PURE__ */ jsx(
              "span",
              {
                style: {
                  fontSize: 12,
                  fontWeight: 600,
                  lineHeight: "20px",
                  color: isOpen ? OPEN_PILL_FG : CLOSED_PILL_FG,
                  background: isOpen ? OPEN_PILL_BG : CLOSED_PILL_BG,
                  padding: "6px 16px",
                  borderRadius: 100,
                  whiteSpace: "nowrap",
                  flexShrink: 0
                },
                children: openPillLabel(store)
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "16px",
                color: "var(--voice-widget-fg, #111827)",
                marginTop: 4,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              },
              title: `${store.address}, ${store.city}, ${store.state} ${store.zipcode}`,
              children: [
                store.address,
                ", ",
                store.city,
                ", ",
                store.state,
                " ",
                store.zipcode
              ]
            }
          ),
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: 8, marginTop: 12 }, children: [
            /* @__PURE__ */ jsxs(
              "a",
              {
                href: buildDirectionsUrl(store),
                target: "_blank",
                rel: "noopener noreferrer",
                style: ctaButtonStyle("primary", isCompact),
                "aria-label": "Directions",
                title: isCompact ? "Directions" : void 0,
                children: [
                  /* @__PURE__ */ jsx(DirectionsIcon, {}),
                  !isCompact && /* @__PURE__ */ jsx("span", { children: "Directions" })
                ]
              }
            ),
            store.phone && /* @__PURE__ */ jsxs(
              "a",
              {
                href: normalizePhoneHref(store.phone),
                style: ctaButtonStyle("secondary", isCompact),
                title: store.phone,
                "aria-label": `Call ${store.phone}`,
                children: [
                  /* @__PURE__ */ jsx(CallIcon, {}),
                  !isCompact && /* @__PURE__ */ jsx("span", { children: "Call" })
                ]
              }
            ),
            store.website && /* @__PURE__ */ jsxs(
              "a",
              {
                href: store.website,
                target: "_blank",
                rel: "noopener noreferrer",
                style: ctaButtonStyle("secondary", isCompact),
                "aria-label": "Website",
                title: isCompact ? "Website" : void 0,
                children: [
                  /* @__PURE__ */ jsx(WebsiteIcon, {}),
                  !isCompact && /* @__PURE__ */ jsx("span", { children: "Website" })
                ]
              }
            )
          ] })
        ] })
      ]
    }
  );
};
function ctaButtonStyle(variant, iconOnly) {
  const isPrimary = variant === "primary";
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    height: 32,
    width: iconOnly ? 40 : 124,
    padding: iconOnly ? 0 : "4px 16px",
    fontSize: 12,
    fontWeight: 600,
    textDecoration: "none",
    lineHeight: "24px",
    letterSpacing: "0.08px",
    borderRadius: 16,
    color: isPrimary ? "var(--voice-widget-button-fg, #FFFFFF)" : "var(--voice-widget-fg, #111827)",
    background: isPrimary ? "var(--voice-widget-button-bg, #111827)" : NEUTRAL_SURFACE_BG,
    border: "none",
    flexShrink: 0,
    boxSizing: "border-box"
  };
}
const StoreListWidget = ({ data }) => {
  const isCompact = useIsCompactVoiceLayout();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: 760,
        margin: "0 auto",
        background: "var(--voice-widget-card-bg, #FFFFFF)",
        border: `1px solid ${BORDER_COLOR}`,
        borderRadius: 10,
        overflow: "hidden",
        animation: "voice-store-list-fade-in 0.28s ease-out both",
        display: "flex",
        flexDirection: "column",
        maxHeight: "min(78vh, 620px)"
      },
      children: [
        /* @__PURE__ */ jsx("style", { children: WIDGET_KEYFRAMES }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              flexShrink: 0,
              padding: "19px 24px 25px",
              borderBottom: `1px solid ${BORDER_COLOR}`
            },
            children: [
              /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    fontSize: 13,
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    color: "var(--voice-widget-muted, rgba(0,0,0,0.5))"
                  },
                  children: "Nearby stores"
                }
              ),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  style: {
                    fontSize: 18,
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "var(--voice-widget-fg, #111827)",
                    marginTop: 8
                  },
                  children: [
                    "Showing stores near ",
                    data.resolvedLocation.label
                  ]
                }
              ),
              data.resolvedLocation.source === "ip" && /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    fontSize: 11,
                    color: "var(--voice-widget-muted, rgba(0,0,0,0.5))",
                    marginTop: 4
                  },
                  children: "Detected from your IP — say a different city or zip if this isn't right."
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx("div", { style: { flex: 1, minHeight: 0, overflowY: "auto" }, children: data.stores.map((store) => /* @__PURE__ */ jsx(StoreCard, { store, isCompact }, store.storeId)) })
      ]
    }
  );
};
export {
  StoreListWidget
};
//# sourceMappingURL=StoreListWidget.js.map
